<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<h4>Reminder Details</h4>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstStationReminderAlert"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedStationReminderAlert"
						dataKey="StationReminderAlertID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--Message-->
								<th>
									<p-columnFilter type="text" field="Message" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--SoundFile-->
								<th>
									<p-columnFilter type="text" field="SoundFile" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--AlertTypeDesc-->
								<th class="OccurColumn">
									<p-columnFilter field="AlertTypeDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterAlertTypeDesc
												[ngModel]="value"
												[options]="lstAlertTypeDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--RangeDesc-->
								<th class="NextOccurColumn">
									<p-columnFilter type="text" field="RangeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="Message">Message<p-sortIcon field="Message"></p-sortIcon></th>
								<th pSortableColumn="SoundFile">Sound<p-sortIcon field="SoundFile"></p-sortIcon></th>
								<th class="OccurColumn" pSortableColumn="AlertTypeDesc">Occurs<p-sortIcon field="AlertTypeDesc"></p-sortIcon></th>
								<th class="NextOccurColumn" pSortableColumn="RangeDesc">Next Occurrence<p-sortIcon field="RangeDesc"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-StationReminderAlert>
							<tr [pSelectableRow]="StationReminderAlert">
								<td
									style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
									[style.color]="StationReminderAlert.MessageFontColor"
								>
									{{ StationReminderAlert.Message }}
								</td>

								<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
									{{ StationReminderAlert.SoundFile }}
								</td>

								<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" class="OccurColumn">
									{{ StationReminderAlert.AlertTypeDesc }}
								</td>

								<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" class="NextOccurColumn">
									{{ StationReminderAlert.RangeDesc }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>
			</div>
		</div>
	</div>
</div>
